export { DefaultFontStyles, registerDefaultFontFaces } from '@fluentui/theme/lib/fonts/DefaultFontStyles';
